const NONE = { NONE: 'none' };

export const TYPE = {
	ALLOY: 'Alloy',
	ARMOR: 'Armor',
	BOLT: 'Bolt',
	BEAST: 'Beast',
	BOMB: 'Bomb',
	CONDIMENT: 'Condiment',
	CREATION: 'Creation',
	CRYSTAL: 'Crystal',
	DYE: 'Dye',
	ELEMENTAL: 'Elemental',
	ESSENCE: 'Essence',
	FERTILIZER: 'Fertilizer',
	FOOD: 'Food',
	FUEL: 'Fuel',
	HEADGEAR: 'Headgear',
	HEAL: 'Heal',
	MAGIC: 'Magic',
	PAPER: 'Paper',
	POISON: 'Poison',
	PORCELAIN: 'Porcelain',
	RECOVERY: 'Recovery',
	REFINE: 'Refine',
	SAND: 'Sand',
	SHIELD: 'Shield',
	TALISMAN: 'Talisman',
	TONIC: 'Tonic',
	TOOL: 'Tool',
	TRANSFIGURE: 'Transfigure',
	WEAPON: 'Weapon',
	WOOD: 'Wood',
};

export const ELEMENT = {
	AIR: 'Air',
	EARTH: 'Earth',
	FIRE: 'Fire',
	WATER: 'Water',
};

export const BASE = {
	AWAKENING: 'Awakening Potion',
	BERSERK: 'Berserk Potion',
	CONCENTRATION: 'Concentration Potion',
}

export const CATALYST = {
	...NONE,
	// Natural.
	BLUE_GEMSTONE: 'Blue Gemstone',
	CYFAR: 'Cyfar',
	RED_GEMSTONE: 'Red Gemstone',
	YELLOW_GEMSTONE: 'Yellow Gemstone',
	// Synthesized.
	GARM_ESSENCE: 'Garm\'s Essence',
	IFRIT_ESSENCE: 'Ifrit\'s Essence',
	MAYA_ESSENCE: 'Maya\'s Essence',
	MISTRESS_ESSENCE: 'Mistress\'s Essence',
};

export const CATALYST_SYNTHESIZED = {
	[`${CATALYST.IFRIT_ESSENCE}`]: 40080,
	[`${CATALYST.MAYA_ESSENCE}`]: 40081,
	[`${CATALYST.MISTRESS_ESSENCE}`]: 40082,
	[`${CATALYST.GARM_ESSENCE}`]: 40083,
};

export const AGENT = {
	[`${ELEMENT.FIRE}`]: {
		RED_BLOOD: {
			id: 990,
			quality: 0,
			fire: 20,
			earth: 0,
			air: 0,
			water: 0
		}
	}
}

export const SPEC_MAIN = {
	...NONE,
};
